import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { DrugAlcoholRecordEntity } from './drug-alcohol-record.model';

/* eslint-disable @typescript-eslint/no-shadow */
export enum DrugAlcoholRecordActionTypes {
  LoadDrugAlcoholRecords = '[DrugAlcoholRecord] Load DrugAlcoholRecords',
  AddDrugAlcoholRecord = '[DrugAlcoholRecord] Add DrugAlcoholRecord',
  UpsertDrugAlcoholRecord = '[DrugAlcoholRecord] Upsert DrugAlcoholRecord',
  AddDrugAlcoholRecords = '[DrugAlcoholRecord] Add DrugAlcoholRecords',
  UpsertDrugAlcoholRecords = '[DrugAlcoholRecord] Upsert DrugAlcoholRecords',
  UpdateDrugAlcoholRecord = '[DrugAlcoholRecord] Update DrugAlcoholRecord',
  UpdateDrugAlcoholRecords = '[DrugAlcoholRecord] Update DrugAlcoholRecords',
  DeleteDrugAlcoholRecord = '[DrugAlcoholRecord] Delete DrugAlcoholRecord',
  DeleteDrugAlcoholRecords = '[DrugAlcoholRecord] Delete DrugAlcoholRecords',
  ClearDrugAlcoholRecords = '[DrugAlcoholRecord] Clear DrugAlcoholRecords',
}
/* eslint-enable @typescript-eslint/no-shadow */

export class LoadDrugAlcoholRecords implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.LoadDrugAlcoholRecords;

  constructor(public payload: { drugAlcoholRecords: DrugAlcoholRecordEntity[] }) {}
}

export class AddDrugAlcoholRecord implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.AddDrugAlcoholRecord;

  constructor(public payload: { drugAlcoholRecord: DrugAlcoholRecordEntity }) {}
}

export class UpsertDrugAlcoholRecord implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.UpsertDrugAlcoholRecord;

  constructor(public payload: { drugAlcoholRecord: DrugAlcoholRecordEntity }) {}
}

export class AddDrugAlcoholRecords implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.AddDrugAlcoholRecords;

  constructor(public payload: { drugAlcoholRecords: DrugAlcoholRecordEntity[] }) {}
}

export class UpsertDrugAlcoholRecords implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.UpsertDrugAlcoholRecords;

  constructor(public payload: { drugAlcoholRecords: DrugAlcoholRecordEntity[] }) {}
}

export class UpdateDrugAlcoholRecord implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.UpdateDrugAlcoholRecord;

  constructor(public payload: { drugAlcoholRecord: Update<DrugAlcoholRecordEntity> }) {}
}

export class UpdateDrugAlcoholRecords implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.UpdateDrugAlcoholRecords;

  constructor(public payload: { drugAlcoholRecords: Update<DrugAlcoholRecordEntity>[] }) {}
}

export class DeleteDrugAlcoholRecord implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.DeleteDrugAlcoholRecord;

  constructor(public payload: { id: string }) {}
}

export class DeleteDrugAlcoholRecords implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.DeleteDrugAlcoholRecords;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDrugAlcoholRecords implements Action {
  public readonly type = DrugAlcoholRecordActionTypes.ClearDrugAlcoholRecords;
}

export type DrugAlcoholRecordActions =
  | LoadDrugAlcoholRecords
  | AddDrugAlcoholRecord
  | UpsertDrugAlcoholRecord
  | AddDrugAlcoholRecords
  | UpsertDrugAlcoholRecords
  | UpdateDrugAlcoholRecord
  | UpdateDrugAlcoholRecords
  | DeleteDrugAlcoholRecord
  | DeleteDrugAlcoholRecords
  | ClearDrugAlcoholRecords;
